import React from 'react';
import { PAGE_CONFIG } from './pageConfig';
import CommonPageRender from '@/pages/dashboard/components/PageContainer/CommonPageRender';
import './index.scss';

const reqParams = '/benchmark/gtdrAssessment';

const GtdrAssessment = () => {
  return (
    <div className='dbd-benchmark-gtdrAssessment-CommonHeader'>
      <CommonPageRender
        reqParams={reqParams}
        pageConfigInit={PAGE_CONFIG}
        renderPageContainer={false}
      />
    </div>
  );
};

export default GtdrAssessment;

